import { render, staticRenderFns } from "./multiple.vue?vue&type=template&id=7236a7b2&lang=pug"
import script from "./multiple.vue?vue&type=script&lang=js"
export * from "./multiple.vue?vue&type=script&lang=js"
import style0 from "./multiple.vue?vue&type=style&index=0&id=7236a7b2&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports